import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ContactModule } from './contact/contact.module';
import { PanchakrushnaModule } from './panchakrushna/panchakrushna.module';
import { HttpClientModule } from '@angular/common/http'
import { SongsModule } from './songs/songs.module';
import { BooksModule } from './books/books.module';
import { SmrutiModule } from './smruti/smruti.module';
import { FormsModule } from '@angular/forms';
import { CharitraModule } from './charitra/charitra.module';
import { AccordionModule } from './accordion/accordion.module';
import { SutrapathModule } from './sutrapath/sutrapath.module';
import { ArtiModule } from './arti/arti.module';
import { GallaryModule } from './gallary/gallary.module';
import { SthanModule } from './sthan/sthan.module';
import { AndroidModule } from './android/android.module';
import { VideosModule } from './videos/videos.module';
import { TncComponent } from './tnc/tnc.component';
import { CopyrightsComponent } from './copyrights/copyrights.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { SthandarshanModule } from './sthandarshan/sthandarshan.module';
import { GoogleMapsModule } from '@angular/google-maps'

@NgModule({
  declarations: [
    AppComponent,
    TncComponent,
    CopyrightsComponent,
    DisclaimerComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HomeModule,
    ContactModule,
    SongsModule,
    BooksModule,
    PanchakrushnaModule,
    SmrutiModule,
    SutrapathModule,
    CharitraModule,
    ArtiModule,
    GallaryModule,
    SthanModule,
    AndroidModule,
    VideosModule,
    AccordionModule,
    HttpClientModule,
    FormsModule,
    SthandarshanModule,
    GoogleMapsModule
  ],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
